import service from "services/maintenance/employeePayClassService";
import { RealEstateAgentOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";
import PAYROLL_HELPER from "utils/helpers/payrollHelper";

const employmentStatusResource = {
    title: "Pay Classifications",
    singular: "Pay Classifications",
    displayField: "description",
    service: service,
    pageIcon: RealEstateAgentOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.EMPLOYEE_PAY_CLASS,

    columns: [
        {
            field: "employeePayClassCode",
            header: "Pay Class Code",
            width: "15%"
        },
        {
            field: "description",
            header: "Description"
        },
        {
            field: "payFrequency",
            header: "Pay Frequency",
            type: "select",
            options: PAYROLL_HELPER.frequencyOptions()
        }
    ],
    fields: [
        {
            name: "employeePayClassCode",
            label: "Pay Class Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        },
        {
            name: "payFrequency",
            label: "Pay Frequency",
            type: "select",
            required: true,
            options: PAYROLL_HELPER.frequencyOptions()
        }
    ],
    searchFields: ["employeePayClassCode", "description"]
};

export default employmentStatusResource;
